import template from './ps-filter-entry.html';
// import FilterGroup from '../ps-record-filter/FilterGroup';

/**
 * KO component for filtering api/record data
 *
 * @kind component
 * @class FilterEntryViewModel
 *
 * @param {Object} params - The parameters object for the component.
 * @param {HTMLElement} rootElement - The root element that the component is bound to
 * @param {string} [params.show_filter] - Controls if the component is visible. Can be an observable
 */
class FilterEntryViewModel
{
	constructor(params, rootElement)
	{
		this.params = params;
		this.filter;
		this.fields = ko_helper.safe_observableArray(params.fields, []);

		this.allowed_operations = [
			{ value: '=', text: 'is' },
			{ value: '!=', text: 'is not' },
			{ value: '<', text: 'is less than' },
			{ value: '<=', text: 'is less than or equal' },
			{ value: '>', text: 'is greater than' },
			{ value: '>=', text: 'is greater than or equal' },
			{ value: 'LIKE', text: 'is like' },
			{ value: 'ILIKE', text: 'is like (case-insensitive)' },
			{ value: 'IS_NULL', text: 'is null' },
			{ value: 'IS_NOT_NULL', text: 'is not null' }
		];

		const FilterGroup = Grape.dataModel.get('FilterGroup');
		this.model = params.filter ?? new FilterGroup({ context: params.context });
		this.entryType = ko.pureComputed(() => {
			if (this.model.filter && this.model.join)
				return 'FilterGroup';
			else
				return 'FilterEntry';
		});

		this.restrictFields = ko.pureComputed(() => {
			return this.fields() && this.fields()?.length >= 1;
		});

		// Create a computed field configuration for the selected field
		this.selected_field_config = ko.pureComputed(() => {
			let selectedField = this.model.field ? this.model.field() : null;

			if (!selectedField)
			{
				console.log('No selected field, returning null');
				return null;
			}

			// Find the field in the fields array
			let field = null;

			if (selectedField && typeof selectedField === 'object' && selectedField.name)
				field = selectedField;
			else
			{
				// Otherwise, search for it in the fields array
				field = this.fields().find(f => {
					// selectedField could be a string or an object
					if (typeof selectedField === 'string')
						return f.name === selectedField || f.field === selectedField || f.field_name === selectedField;
					else
						return f.name === selectedField.name || f.field === selectedField.field;
				});
			}

			if (!field)
				return null;

			// Create a field configuration for ko-field-input with unwrapped values
			let field_config = {
				type: ko.unwrap(field.type) || 'text',
				name: ko.unwrap(field.name) || ko.unwrap(field.field) || ko.unwrap(field.field_name),
				label: ko.unwrap(field.name) || ko.unwrap(field.field) || ko.unwrap(field.field_name),
				options: ko.unwrap(field.options) || {},
				$input: this.model.value
			};

			return field_config;
		});
	}

	toggle_join()
	{
		if (this.model.join() === 'AND')
			this.model.join('OR');
		else
			this.model.join('AND');
	}
}

export default {
	name: 'ps-filter-entry',
	viewModel: FilterEntryViewModel,
	module_type: 'ko',
	template: template
};
